import React from "react";
import Heading from "../common/ui/Heading";
import { SOCIAL_WORK_LIST } from "../../utils/other-component";

const SocialWork = () => {
  return (
    <>
      <div className="px-4 bg-[#EAF3EE] py-[100px] max-lg:py-16 max-md:py-12 max-sm:py-10">
        <Heading children="Glimpse of Social Work" className="text-center" />
        <div className="max-w-[1140px] mx-auto pt-[50px]">
          <div className="flex items-center justify-center gap-6 flex-wrap">
            {SOCIAL_WORK_LIST.map((obj, i) => (
              <div
                key={i}
                className="w-full max-w-[364px] max-lg:max-w-[350px] max-lg:mx-auto border border-solid border-transparent rounded-2xl shadow-[0px_4px_17.7px_0px_#0000001A] p-[1px] transition-all ease-linear duration-300 bg-[linear-gradient(270.39deg,rgba(152,198,78,0.7)_2.61%,rgba(63,138,49,0.7)_96.31%)] h-[326px]"
              >
                <div className="w-full h-full rounded-2xl bg-[#FEFEFE] p-5">
                  <img
                    src={obj.icon}
                    alt="icons"
                    className="w-full max-w-[60px] size-[60px]"
                  />
                  <h2 className="text-[#001A3D] font-semibold text-xl leading-[130%] pt-[22px]">
                    {obj.title}
                  </h2>
                  {i === 0 && (
                    <p className="font-normal text-base leading-[150%] pt-4">
                      <span className="text-[#010101] font-medium">
                        Location:
                      </span>
                      {obj.location}
                    </p>
                  )}
                  <p className="font-normal text-base leading-[150%] pt-4">
                    {obj.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialWork;
